<template>
  <div class="form-wrap">
    <label :for="field">{{ $t(fieldLabel) }}</label>
    <input
      v-on="listeners"
      :value="value"
      class="form-input"
      :type="type"
      :step="step"
      :name="field"
      :id="field"
      :placeholder="placeholder"
    />
  </div>
</template>

<script>
import { camelCase } from 'lodash'

export default {
  name: 'TextInputField',
  props: {
    field: { type: String, required: true },
    value: { type: [String, Number], default: '' },
    modelTranslationKey: { type: String, default: 'containers' },
    labelTranslationKey: [String],
    placeholder: [String],
    type: { type: String, default: 'text' },
    step: { type: String },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: event => {
          this.$emit('input', event.target.value)
        },
      }
    },
    fieldLabel() {
      return this.labelTranslationKey || `${this.modelTranslationKey}.${camelCase(this.field)}`
    },
  },
}
</script>
